<template>
    <v-row>
        <v-col cols=12 sm=6>
            <v-currency-field
                label="Valor de mercado de tu vivienda *"
                v-model="preScoring.Vivienda.valor"
                :rules="[...ruleMin10000,...ruleMax100M]"
                outlined
                append-icon="mdi-currency-eur"
                hint="Si no conoces la cantidad definitiva introduce una estimación"
                persistent-hint
                dense
            ></v-currency-field>
        </v-col>
        <v-col cols=12 sm=6>
            <v-currency-field
                label="¿Qué liquidez necesitas? *"
                outlined
                v-model="preScoring.Vivienda.liquidez"
                :rules="[...ruleRequired,...ruleMax100M]"
                append-icon="mdi-currency-eur"
                dense
            ></v-currency-field>
        </v-col>
        <v-col cols=12 sm=6>
            <v-currency-field
                label="¿Tienes otros préstamos que quieras incluir? *"
                outlined
                v-model="preScoring.Vivienda.otros_prestamos"
                :rules="[...ruleRequired,...ruleMax100M]"
                :min="0"
                placeholder="40.000€"
                append-icon="mdi-currency-eur"
                hint="Si tienes préstamos y quieres incluirlos en esta hipoteca, por favor ingresa cuanto debes a fecha de hoy"
                persistent-hint
                dense
            ></v-currency-field>
        </v-col>
        
        <v-col cols=12 sm=6>
            <v-text-field
                label="Dirección de la vivienda (si la tiene)"
                outlined
                v-model="preScoring.Vivienda.direccion"
                dense
            ></v-text-field>
        </v-col>
        <v-col cols=12 sm=6>
            <v-autocomplete 
                label="Comunidad autónoma *"
                outlined
                v-model="preScoring.Vivienda.ccaa"
                :items="commonVars.ccaa"
                :rules="[...ruleRequired]"
                item-text="name"
                item-value="code"
                dense
            />
        </v-col>
        <v-col cols=12 sm=6>
            <v-text-field
                label="Código postal"
                outlined
                v-model="preScoring.Vivienda.cp"
                dense
            ></v-text-field>
        </v-col>
        <v-col cols=12 sm=12>
            <v-textarea
                label="Comentario"
                placeholder='Explícanos los detalles relevantes de tu operación. Cuantos más detalles nos cuentes, más conocimiento de lo que estás buscando y mejores soluciones te propondremos'
                v-model="preScoring.Vivienda.comentario"
                outlined
                dense
            ></v-textarea>
        </v-col>
    </v-row>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import rulesMixin from '../../mixins/rulesMixin';

    export default {
        mixins: [rulesMixin],
        components:{
        },
        methods: {
            ...mapMutations([
                'SET_ACTIVE_STEP',
                'SET_DATE_KEYS',
                'SET_VALUE'
            ]),
        },
        computed: {
            ...mapState([
                'preScoring',
                'commonVars',
                'token_id',
                'propertyStatuses',
                'propertyNew'
            ]),
        },

    }
</script>
